<mat-dialog-content>
  <div class="dialog__wrapper dialog__wrapper--flex">
    <div class="dialog__header">
      <img src="https://yp-explorer.s3.amazonaws.com/v2/illus_broken-leash.svg" alt="" /> 
    </div>

    <div class="dialog__content">
      <p class="page__title mt10" i18n="@@dialog.block.title">Forbidden access</p>
      <p class="page__intro page__intro--grey" i18n="@@dialog.block.desc">The application is not available in your country.</p>

      <div class="halign--right text--center">
        <button type="button"
                (click)="confirm()"
                class="btn btn--primary" i18n="global.btn.ok">Ok</button>
      </div>
    </div>
  </div>
</mat-dialog-content>
